import { render, staticRenderFns } from "./ReferralInstitutiontEdit.vue?vue&type=template&id=5b0afe74&scoped=true"
import script from "./ReferralInstitutiontEdit.vue?vue&type=script&lang=js"
export * from "./ReferralInstitutiontEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0afe74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0afe74')) {
      api.createRecord('5b0afe74', component.options)
    } else {
      api.reload('5b0afe74', component.options)
    }
    module.hot.accept("./ReferralInstitutiontEdit.vue?vue&type=template&id=5b0afe74&scoped=true", function () {
      api.rerender('5b0afe74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/referralInstitutiont/ReferralInstitutiontEdit.vue"
export default component.exports